export enum OrderUserProfileFilter {
  ALL = 'ALL',
  B2C = 'B2C',
  B2B = 'B2B',
}
